/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export enum lineHeights {
  h1 = '46px',
  h2 = '32px',
  h3 = '28px',
  h4 = '24px',
  h5 = '24px',
  h6 = '24px',
  body = '24px',
  body1 = '24px',
  caption = '16px',
  title = '48px',
  modalTitle = '42px'
}

enum spacing {
  xxxs = '4px',
  xxs = '8px',
  xs = '12px',
  sm = '16px',
  md = '24px',
  lg = '32px',
  xl = '40px',
  xxl = '48px',
  xxxl = '64px',
  xxxxl = '80px'
}

type Spacing = keyof typeof spacing;

export function multipliedBy(spacingSize: Spacing, multiplier: number) {
  const size = spacing[spacingSize];
  const quantity = Number.parseInt(size.split('px')[0], 10);
  const product = quantity * multiplier;
  return product + 'px';
}

export default spacing;
